export const ServiceHeadersContentTypeJson = {
  'Content-Type': `application/json`,
}
